export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const CHECK_EMAIL_STATUS = "CHECK_EMAIL_STATUS";

export const IS_VERIFIED = "IS_VERIFIED";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const HIDE_MODAL = "HIDE_MODAL";
export const SHOW_MODAL = "SHOW_MODAL";
export const SHOW_STEPS = "SHOW_STEPS";
export const HIDE_STEPS = "HIDE_STEPS";

export const SHOW_REGISTER = "SHOW_REGISTER";
export const SHOW_LOGIN = "SHOW_LOGIN";
export const SHOW_RESET_PASSWORD = "SHOW_RESET_PASSWORD";
export const SHOW_VERIFY_EMAIL = "SHOW_VERIFY_EMAIL";
